import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ActiveTypeEnum } from '../../../core/enums/master.enum';
import { Dropdown } from '../../../models/shared-component/drop-down.model';
import { MasterEquipmentSelectorResponse } from 'src/app/models/setting-model/master-equipment.model';

@Component({
  selector: 'app-create-edit-modal-v2',
  templateUrl: './create-edit-modal-v2.component.html',
  styleUrls: ['./create-edit-modal-v2.component.scss']
})
export class CreateEditModalV2Component implements OnInit {

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
  ) { }

  @Input() public titleModal: string = "";
  @Input() public id: number;

  @Input() public firstTitleName: string = "";
  @Input() public firstTitleIsSelector: boolean;
  @Input() public firstListItem: Dropdown[];
  @Input() public firstTitleIsValidate: boolean;
  @Input() public firstId: number;
  @Input() public firstName: string = "";

  @Input() public secondTitleName: string = "";
  @Input() public secondTitleIsSelector: boolean;
  @Input() public secondListItem: Dropdown[];
  @Input() public secondTitleIsValidate: boolean;
  @Input() public secondId: number;
  @Input() public secondName: string = "";
  @Input() public secondTitleIsNumber: boolean;

  @Input() public status: boolean = true;
  @Input() public callback: Function
  @Output() res = new EventEmitter<boolean>();

  @Input() public showMultiples: boolean = false;
  @Input() public multipleValue: boolean = false;

  @Input() public haveEquipmentCategory: boolean = false;
  @Input() public itemEquipmentCategoryList: MasterEquipmentSelectorResponse[] = [];
  @Input() public categoryIdList: number[];

  @Input() public haveEquipmentGroup: boolean = false;
  @Input() public itemEquipmentGroupList: MasterEquipmentSelectorResponse[] = [];
  @Input() public groupIdList: number[];

  @Input() public showHexColor: boolean = false;
  @Input() public hexColor: string = "";


  activeTypeStatus = ActiveTypeEnum;
  requiredName: boolean = false;

  public form: FormGroup;

  ngOnInit(): void {
    this.initialForm();
  }


  initialForm(): void {
    this.form = this.formBuilder.group({
      id: [this.id],
      firstId: [this.firstId],
      firstName: [this.firstName],
      secondId: [this.secondId],
      secondName: [this.secondName],
      status: [this.status],
      multipleValue: [this.multipleValue],
      categoryIdList: [this.categoryIdList],
      groupIdList: [this.groupIdList],
      hexColor: [this.hexColor]
    });

    if (this.firstTitleIsValidate) {
      if (this.firstTitleIsSelector) {
        this.form.get('firstId')?.setValidators(Validators.required);
      }
      else {
        this.form.get('firstName')?.setValidators(Validators.required);
      }
    }
    if (this.secondTitleIsValidate) {
      if (this.secondTitleIsSelector) {
        this.form.get('secondId')?.setValidators(Validators.required);
      }
      else {
        this.form.get('secondName')?.setValidators(Validators.required);
      }
    }
  }

  closeModal() {
    this.activeModal.close();
  }

  onSave() {
    if (this.form.invalid) {
      Object.keys(this.form['controls']).forEach(key => { this.form['controls'][key].markAsTouched(); });
      return;
    }

    this.callback(this.form.getRawValue());
  }


  isFormInvalid(formControlName: string): boolean {
    return (this.form.controls[formControlName].touched || this.form.controls[formControlName].dirty) && this.form.controls[formControlName].invalid
  }

  onlyAllowNumbers(event: KeyboardEvent) {
    const charCode = event.charCode ? event.charCode : event.keyCode;
    // Allow only digits (0-9)
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }

  onInputChange(event: Event) {
    const input = (event.target as HTMLInputElement);
    input.value = input.value.replace(/[^0-9]/g, ''); // Remove any non-numeric characters
  }
}
